<app-title-component [data]="{name: 'Ravitaillement'}"></app-title-component>

<div class="page-container p-4 bg-light min-vh-100">
  <mat-card appearance="outlined" class="main-supply-card border-0 shadow-sm">
    
    <mat-card-header class="p-3 bg-white border-bottom d-flex align-items-center justify-content-between">
      <span class="text-secondary small fw-semibold text-uppercase tracking-wider">Gestion des flux</span>
      <button mat-flat-button type="button" color="primary" class="px-4 py-2" (click)="loadCollaborateur()">
        <mat-icon class="me-1">list_alt</mat-icon>
        <span>Distribution</span>
      </button>
    </mat-card-header>

    @if (partenaire().id !== '') {
      <mat-card-content class="p-4 bg-white">
        
        <!-- Fiche info collaborateur modernisée -->
        <div class="partner-info-banner rounded-3 p-3 mb-4 border d-flex flex-column flex-md-row align-items-md-center justify-content-between gap-3">
          <div class="d-flex align-items-center">
            <div class="avatar-wrapper me-3">
              <img [src]="path + partenaire().collaborateur_logo" alt="Logo" class="avatar-img" (error)="$event.target.style.display='none'">
            </div>
            <div>
              <h2 class="h6 fw-bold text-dark m-0">{{ partenaire().collaborateur_name }}</h2>
              <span class="text-muted small">Réf: <code class="fw-semibold text-dark">{{ partenaire().code_partenaire }}</code></span>
            </div>
          </div>

          <div class="partner-meta-grid flex-grow-1 mx-md-4">
            <div class="meta-item">
              <span class="meta-label">Compagnie</span>
              <span class="meta-value text-dark fw-medium">{{ partenaire().compagnie_name }}</span>
            </div>
            <div class="meta-item">
              <span class="meta-label">Propriétaire</span>
              <span class="meta-value text-secondary">{{ partenaire().collaborateur_owner }}</span>
            </div>
            <div class="meta-item">
              <span class="meta-label">Adresse</span>
              <span class="meta-value text-muted text-truncate" style="max-width: 150px;" [matTooltip]="partenaire().collaborateur_adresse">
                {{ partenaire().collaborateur_adresse }}
              </span>
            </div>
          </div>

          <div class="partner-badge-status flex-shrink-0">
            <span class="badge-stock">Restant : {{ partenaire().document_reste! }} doc.</span>
          </div>
        </div>

        <!-- Formulaire de distribution segmenté et aligné -->
        <div [formGroup]="distForm" class="distribution-form-panel p-4 rounded-3 border bg-light">
          
          <!-- Ligne Document -->
          <div class="row align-items-center g-3 mb-4">
            <div class="col-12 col-md-2 text-md-end">
              <span class="form-row-title text-dark fw-bold small text-uppercase">Document</span>
            </div>
            <div class="col-12 col-sm-6 col-md-5">
              <mat-form-field appearance="outline" class="w-100 background-white-field">
                <mat-label>Type de document</mat-label>
                <mat-select formControlName="type" #select (selectionChange)="activeControl('qte', $event.value)">
                  <mat-option disabled>Sélectionner le type de doc.</mat-option>
                  <mat-option value="A">Automobile</mat-option>
                  <mat-option value="M">Motocycle</mat-option>
                  <mat-option value="T">Taxi</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="col-12 col-sm-6 col-md-5">
              <mat-form-field appearance="outline" class="w-100 background-white-field">
                <mat-label>Nbre de documents</mat-label>
                <input matInput #input qteInput formControlName="qte" (blur)="activeControl('attestation_start', input.value)" type="number" placeholder="Entrez la quantité">
              </mat-form-field>
            </div>
          </div>

          <!-- Ligne Attestation -->
          <div class="row align-items-center g-3 mb-4">
            <div class="col-12 col-md-2 text-md-end">
              <span class="form-row-title text-dark fw-bold small text-uppercase">Attestation</span>
            </div>
            <div class="col-12 col-sm-6 col-md-5">
              <mat-form-field appearance="outline" class="w-100 background-white-field">
                <mat-label>De</mat-label>
                <input matInput type="number" formControlName="attestation_start" (input)="setAttestationEndValue()" placeholder="N° début">
              </mat-form-field>
            </div>
            <div class="col-12 col-sm-6 col-md-5">
              <mat-form-field appearance="outline" class="w-100 background-white-field">
                <mat-label>À</mat-label>
                <input matInput formControlName="attestation_end" type="number" placeholder="N° fin">
              </mat-form-field>
            </div>
          </div>

          <!-- Ligne Carte Rose -->
          <div class="row align-items-center g-3">
            <div class="col-12 col-md-2 text-md-end">
              <span class="form-row-title text-dark fw-bold small text-uppercase">Carte Rose</span>
            </div>
            <div class="col-12 col-sm-6 col-md-5">
              <mat-form-field appearance="outline" class="w-100 background-white-field">
                <mat-label>De</mat-label>
                <input matInput type="number" formControlName="carte_rose_start" (input)="setCarteRoseEndValue()" placeholder="N° début">
              </mat-form-field>
            </div>
            <div class="col-12 col-sm-6 col-md-5">
              <mat-form-field appearance="outline" class="w-100 background-white-field">
                <mat-label>À</mat-label>
                <input matInput formControlName="carte_rose_end" type="number" placeholder="N° fin">
              </mat-form-field>
            </div>
          </div>

        </div>

      </mat-card-content>

      <mat-card-actions align="end" class="p-3 border-top bg-light gap-2">
        <button type="button" (click)="onShare()" [disabled]="distForm.invalid || distForm.get('carte_rose_end')?.value === ''" mat-flat-button color="primary" class="px-4 py-2">
          <mat-icon class="me-1">save</mat-icon>
          <span>Enregistrer la distribution</span>
        </button>
      </mat-card-actions>
    }
  </mat-card>
</div>
